import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const S3StorageSlowDownError = BaseErrorSchema.extend({
  errorType: z.literal('S3StorageSlowDownError'),
  bucketName: z.string(),
  bucketRegion: z.string(),
  key: z.string(),
});

export type S3StorageSlowDownError = z.infer<typeof S3StorageSlowDownError>;
